import { render, staticRenderFns } from "./OrderGiveInfo.vue?vue&type=template&id=27cd29c1&"
import script from "./OrderGiveInfo.vue?vue&type=script&lang=js&"
export * from "./OrderGiveInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderGiveInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports